/**
 * Faq — a centred FAQ section (DS core): a centred eyebrow/badge + title, then
 * the shared FaqAccordion (numbered +/× cards, one open at a time) in a centred
 * column, with an optional action/footer below. No image, no two-column split —
 * the same layout used on the pricing page. Content via props; named tokens only.
 */
import type { ReactNode } from "react";
import { FaqAccordion } from "./FaqAccordion";

export type QA = { q: string; a: ReactNode };

export function Faq({
  eyebrow,
  title,
  intro,
  items,
  action,
}: {
  eyebrow?: ReactNode;
  title?: ReactNode;
  intro?: ReactNode;
  items: QA[];
  /** Centred below the list — a footer line or a CTA button. */
  action?: ReactNode;
}) {
  return (
    <section className="bg-surface font-ds">
      <div className="mx-auto max-w-content px-4 py-16 md:px-10 md:py-20">
        <div className="mx-auto max-w-2xl text-center">
          {eyebrow && <div className="flex justify-center">{eyebrow}</div>}
          {title && <h2 className="mt-6 text-balance font-display text-ds-34 font-semibold leading-[1.1] tracking-[-0.5px] text-ds-ink sm:text-ds-46">{title}</h2>}
          {intro && <p className="mt-4 text-pretty text-ds-18 leading-relaxed text-ds-ink-soft">{intro}</p>}
        </div>

        <div className="mx-auto mt-12 max-w-3xl">
          <FaqAccordion items={items} />
        </div>

        {action && <div className="mt-10 flex justify-center">{action}</div>}
      </div>
    </section>
  );
}
